// Import model
import { Condition } from '../models/Condition';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Condition - handles JSON serialization and deserialization with type validation
 */
export class ConditionSerializer {
  /**
   * Deserializes a JSON string into a Condition instance
   */
  static deserialize(json: string): Condition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Condition instance
   */
  static fromObject(obj: any): Condition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Condition');
    }


    const instance: Condition = {
      fieldName: obj['FieldName'] as string,
      operator: obj['Operator'] as string,
      value: obj['Value'] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Condition instances
   */
  static deserializeArray(json: string): Condition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Condition instance to a JSON string
   */
  static serialize(instance: Condition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Condition instance to a plain object
   */
  static toObject(instance: Condition): any {
    return {
      'FieldName': instance.fieldName,
      'Operator': instance.operator,
      'Value': instance.value,
    };
  }

  /**
   * Serializes an array of Condition instances to a JSON string
   */
  static serializeArray(instances: Condition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
